import { QueryKeys } from "@/constants";
import { fetchUiLabels } from "@/services/ui-labels";
import { useQuery } from "@tanstack/react-query";
import useUserInfo from "./use-user-info";
import type { IUiLabelsResponse } from "@/model/ui-labels";

export const useUiLabels = () => {
  const userInfo = useUserInfo();
  return useQuery<IUiLabelsResponse, Error>({
    queryKey: [QueryKeys.UI_LABELS],
    queryFn: () => fetchUiLabels(userInfo),
    enabled: Boolean(userInfo?.accessToken) && Boolean(userInfo?.groupId),
    staleTime: Infinity,
  });
};
